exports.RegistrationSteps = {
  STEP1: 'step1',
  STEP2: 'step2',
  STEP3: 'step3',
  PENDING: 'pending',
  SUCCESS: 'success',
  APPROVED: 'approved',
};

exports.ApprovalStatus = {
  NOT_SUBMITTED: 'not_submitted',
  PENDING: 'pending',
  NEEDS_MORE_INFO: 'needs_more_info',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};

exports.ApprovalTypes = {
  REGISTRATION: 'registration',
  SERVICE_AREAS: 'service_areas',
};

exports.DriveTypes = {
  CRU: 'CRU',
  USB: 'USB',
};

exports.BandwidthInBps = {
  KILO_BITS_PER_SECOND: 1024,
  MEGA_BITS_PER_SECOND: 1024 * 1024,
  GIGA_BITS_PER_SECOND: 1024 * 1024 * 1024,
  TERA_BITS_PER_SECOND: 1024 * 1024 * 1024 * 1024,
};

exports.BandwidthUnits = {
  KILO_BITS_PER_SECOND: 'Kbps',
  MEGA_BITS_PER_SECOND: 'Mbps',
  GIGA_BITS_PER_SECOND: 'Gbps',
  TERA_BITS_PER_SECOND: 'Tbps',
};

exports.SettingsMenuActions = {
  SHOW_COMPANY_PROFILE: 0,
  DOWNLOAD_CERTIFICATE: 1,
  SIGN_OUT: 2,
  MANAGE_USERS: 3,
};

exports.UserRoleNames = {
  ADMIN: 'admin',
};

exports.PartnerTypes = {
  MANUAL: 'Manual',
  OFFLINE: 'Offline',
  ONLINE: 'Online',
};

exports.WorkOrderStatuses = {
  ASSIGNED: 'assigned',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled',
};

exports.DcpUploadStatuses = {
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
};

exports.DcpDownloadStatuses = {
  NOT_STARTED: 'not_started',
  QUEUED: 'queued',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  FAILED: 'failed',
  PENDING: 'pending',
  ERROR: 'error',
  UNARCHIVING: 'unarchiving',
  ARCHIVED: 'archived',
  STALLED: 'stalled',
};

exports.DcpTransferStatuses = {
  STARTED: 'started',
  COMPLETED: 'completed',
};

exports.WorkOrderItemsFilterValues = {
  PAST: 'past',
  CURRENT: 'current',
  ALL: 'all',
};

exports.BayStatuses = {
  EMPTY: 'empty',
  INSERTED: 'inserted',
  COPYING: 'copying',
  COPY_COMPLETE: 'copy_complete',
  ERROR: 'error',
  AVAILABLE: 'available',
  BUSY: 'busy',
  QUEUED: 'queued',
};

exports.SlotUiStatuses = {
  FAILED: 'failed',
  EMPTY: 'empty',
  INSERTED: 'inserted',
  NORMAL: 'normal',
  EJECT: 'eject',
};

exports.TaskTypes = {
  DUPLICATE_DCPS: 'duplicate_dcps',
  DOWNLOAD_DCPS: 'download_dcps',
};

exports.DuplicationProgress = {
  QUEUED: 'queued',
  SUCCEEDED: 'succeeded',
  EXECUTING: 'executing',
  FAILED: 'failed',
  PREPARING: 'preparing',
  FORMATTING: 'formatting',
  DUPLICATING: 'duplicating',
  VERIFYING: 'verifying',
};

exports.DuplicationErrors = {
  APPLIANCE_OFFLINE: 'appliance_offline',
  DRIVE_IN_USE: 'drive_in_use',
  DCP_NOT_FOUND_IN_APPLIANCE: 'dcp_not_found_in_appliance',
  DCP_NOT_FOUND_IN_STORE: 'dcp_not_found_in_store',
  DRIVE_NOT_ENOUGH_SPACE: 'drive_not_enough_space',
  NO_DRIVES_INSERTED: 'no_drives_inserted',
  APPLIANCE_NOT_FOUND: 'appliance_not_found',
};

exports.WorkOrderTabs = {
  DUPLICATION: 'duplication',
  DELIVERY: 'delivery',
};

exports.ServiceAreaTabs = {
  DRIVE_DELIVERY: 'Drive Delivery',
  ELECTRONIC_DELIVERY: 'Electronic Delivery',
};

exports.ShippingTabColumns = {
  ADDRESS: 'address',
  DELIVERY_INSTRUCTIONS: 'deliveryInstructions',
  DELIVER_BY: 'deliverBy',
  SHIP_BY: 'shipBy',
  SHIPPING_INFO: 'shippingInfo',
  SHIPPED: 'status',
};

exports.ShippingStatus = {
  PENDING: 'pending',
  DISPATCHED: 'dispatched',
  CANCELLED: 'cancelled',
  PENDING_CANCELLATION: 'pending_cancellation',
  REJECTED: 'rejected',
  DELIVERED: 'delivered',
};

exports.ShippedSortIndex = {
  PENDING: 1,
  SHIPPED: 2,
  NOT_AVAILABLE: 3,
};

exports.ShipmentsExcelHeaderColumnNames = {
  SERIAL_NUMBER: 'Serial Number',
  BOOKING_REFERENCE: 'Booking Reference',
  WORK_ORDER_NUMBER: 'Work Order Number',
  COMPOSITIONS: 'Compositions',
  THEATRE_NAME: 'Theatre Name',
  ADDRESS_1: 'Address1',
  ADDRESS_2: 'Address2',
  CITY: 'City',
  STATE: 'State',
  ZIP: 'Zip',
  COUNTRY: 'Country',
  PHONE_NUMBER: 'Phone Number',
  DELIVER_BY: 'Deliver By',
  SHIPPING_COURIER_TYPE: 'Shipping Courier Type',
  SHIPPING_TRACKING_NUMBER: 'Shipping Tracking Number',
  SHIPPING_COMMENTS: 'Shipping Comments',
  RETURN_COURIER_TYPE: 'Return Courier Type',
  RETURN_TRACKING_NUMBER: 'Return Tracking Number',
  RETURN_COMMENTS: 'Return Comments',
  SHIPPING_STATUS: 'Status',
};

exports.ShipmentsExcelStatus = {
  PENDING: 'Pending',
  DISPATCHED: 'Shipped',
  DELIVERED: 'Delivered',
  PENDING_CANCELLATION: 'Pending_cancellation',
  CANCELLED: 'Cancelled',
  REJECTED: 'Rejected',
};

exports.ServiceAreaStatuses = {
  ACTIVE: 'active',
  PENDING: 'pending',
  DELETED: 'deleted',
};

exports.DeliveryOptionStatuses = {
  ACTIVE: 'active',
  PENDING: 'pending',
  DELETED: 'deleted',
};

exports.DeliveryOptionUnit = {
  DAYS: 'days',
  HOURS: 'hours',
};

exports.DeliveryMode = {
  PARTNERS: 'PARTNERS',
  ELECTRONIC: 'ELECTRONIC',
};

exports.DeliveryTypes = {
  HARD_DRIVE: 'HARD_DRIVE',
  SATELLITE: 'SATELLITE',
  INTERNET: 'INTERNET',
};

exports.ElectronicDeliveryType = {
  SATELLITE: 'SATELLITE',
  INTERNET: 'INTERNET',
};

exports.HTTP_STATUS_CODES = {
  NOT_FOUND: 404,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
};

exports.PageSizeOptions = [10, 25, 50];
